import Dates from '../utils/dates';

export default class FirstAcessService {
  static getBlankForm() {
    return {
      cpf: null,
      nascimento: null,
      password: null,
      passwordConfirmation: null,
      captcha: null,
    };
  }

  static formValidation({ password, passwordConfirmation, captcha }, captchaRef) {
    if (password.length < 6) {
      throw new Error('A senha precisa ter no mínimo 6 caracteres');
    }
    if (password !== passwordConfirmation) {
      throw new Error('A senha e sua confirmação não são iguais');
    }
    if (!captchaRef.validate(captcha)) {
      throw new Error('Erro ao preencher o captcha');
    }
  }

  static parseToRequest(form) {
    return {
      cpf: form.cpf,
      nascimento: Dates.parseISO(form.nascimento),
      senha: form.password,
    };
  }
}
